import React, { useState, useEffect } from "react";
import { List, Paper, makeStyles } from "@material-ui/core";

import TreeContainer from "./TreeContainer";
import SearchBar from "../CommonComponents/SearchBar";
import { transformZipData } from "../TreeUtils";
import { useDebounce } from "../../../hooks";

const useStyles = makeStyles(() => ({
  paper: {
    width: 300,
    height: 350,
    overflow: "auto",
    padding: "0 10px",
  },
}));

const CustomList = ({
  listItems = [],
  listHeader,
  selected,
  setSelected,
  searchVal,
  setSearchVal,
}) => {
  const classes = useStyles();
  const [list, setList] = useState(transformZipData(listItems));
  const debouncedSearchValue = useDebounce(searchVal);

  useEffect(() => {
    setList(transformZipData(listItems));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listItems]);

  useEffect(() => {
    setList(
      transformZipData(
        listItems.filter((item) =>
          item.cityWithStateAbbr
            .toLowerCase()
            .includes(debouncedSearchValue.toLowerCase())
        )
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchValue]);

  return (
    <Paper className={classes.paper}>
      <List
        dense
        component="div"
        role="list"
        subheader={
          <SearchBar
            searchVal={searchVal}
            setSearchVal={setSearchVal}
            listHeader={listHeader}
          />
        }
      >
        <TreeContainer
          selected={selected}
          setSelected={setSelected}
          data={list}
        />
      </List>
    </Paper>
  );
};

export default CustomList;
